import React, { Component, Fragment } from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import Fade from 'react-reveal/Fade';
import Zoom from 'react-reveal/Zoom';

import "./Skills.scss";

class Skills extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: props.data
        };
    }

    render() {

        let skills = this.state.data.skills;

        return (
            <section id="skills">
                <Fade left delay={300} duration={800} distance="100%" fraction={0.01}>
                    <div className="section-background"></div>
                </Fade>
                <Container fluid>
                    <Row>
                        <Fade left delay={200} duration={800} distance="20%" fraction={1}>
                            <h2 className="section-title">Skills</h2>
                        </Fade>
                        <Fade right delay={400} duration={800} distance="500px" fraction={1}>
                            <div className="section-title-underline"></div>
                        </Fade>
                    </Row>
                    <Row className="skills-section">
                        {skills.map((skillcol, index) => {
                            let col = "";
                            if (skillcol.col === 1) {
                                col = "skills-col-left";
                            } else if (skillcol.col === 2) {
                                col = "skills-col-middle";
                            } else if (skillcol.col === 3) {
                                col = "skills-col-right";
                            }

                            return <Col key={index} sm={12} md={4} className={`skills-col ${col}`}>
                                {skillcol.skillrows.map((skill, index) => {
                                    return <Zoom delay={300} duration={1000} fraction={0.1}>
                                        <Row className="skill-section">
                                            <Col className="skill-col">
                                                <Image className="skill-image" src={`images/${skill.image}`}></Image>
                                                <h6 className="skill-title">{skill.title}</h6>
                                                <p className="skill-description">{skill.description}</p>
                                                {skill.lists.map((skilllist, index) => {
                                                    return <Fragment>
                                                        <p className="skill-list-title">{skilllist.title}</p>
                                                        <ul className="skill-list">
                                                            {skilllist.list.map((item, index) => {
                                                                return <li className="skill-list-item">{item}</li>
                                                            })}
                                                        </ul>
                                                    </Fragment>
                                                })}
                                            </Col>
                                        </Row>
                                    </Zoom>
                                })}
                            </Col>
                        })}
                    </Row>
                </Container>
            </section>
        );

        // return (
        //     <section id="skills">
        //         <Container fluid>
        //             <Row>
        //                 <h2 className="section-title">Skills</h2>
        //             </Row>
        //             {skills.map((section, index) => {
        //                 let rectPosition = index % 2 === 0 ? "left" : "right";

        //                 return <div key={index} className="skills-section">
        //                     <Row className="title-section">
        //                         <div className={`background-shape ${rectPosition}`} style={{ borderTopColor: section.color }}></div>
        //                         <h3 className="title">{section.category}</h3>
        //                     </Row>
        //                     <Row className="skill-list-section">
        //                         {section.skills.map((skill, index) => (
        //                             <Col key={index} className="skill">
        //                                 <Row>
        //                                     <Image className="image" src={`/images/${skill.image}`} />
        //                                 </Row>
        //                                 <Row>
        //                                     <h5 className="name">{skill.name}</h5>
        //                                 </Row>
        //                             </Col>
        //                         ))}
        //                     </Row>
        //                 </div>
        //             })}
        //         </Container>
        //     </section>
        // );
    }
}

export default Skills;
